module.exports = __webpack_public_path__ + "static/media/grinning-face-with-big-eyes-svgrepo-com.5a5f859c.svg";